<template>
  <Badge :variant="ACTION_BADGES[action].variant" :icon="ACTION_BADGES[action].icon">
    {{ t(action) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { EyeOffIcon, LinkIcon, PlusIcon } from 'lucide-vue-next';
import type { Component } from 'vue';
import { useI18n } from 'vue-i18n';
import { BankStatementAction } from '@carvia/ros-client-types';

defineProps<{
  action: BankStatementAction;
}>();

const { t } = useI18n();

const ACTION_BADGES: Record<BankStatementAction, { icon: Component; variant: BadgeVariant }> = {
  [BankStatementAction.CREATE_PAYMENT]: { icon: PlusIcon, variant: 'info' },
  [BankStatementAction.LINK_PAYMENT]: { icon: LinkIcon, variant: 'walnut' },
  [BankStatementAction.LINK_SETTLEMENT]: { icon: LinkIcon, variant: 'walnut' },
  [BankStatementAction.IGNORE]: { icon: EyeOffIcon, variant: 'obsidian' },
};
</script>

<i18n lang="json">
{
  "en": {
    "CREATE_PAYMENT": "New payment",
    "LINK_PAYMENT": "Existing payment",
    "LINK_SETTLEMENT": "Merchant payout",
    "IGNORE": "Ignore"
  },
  "de": {
    "CREATE_PAYMENT": "Neue Zahlung",
    "LINK_PAYMENT": "Bestehende Zahlung",
    "LINK_SETTLEMENT": "Händlerauszahlung",
    "IGNORE": "Ignorieren"
  },
  "es": {
    "CREATE_PAYMENT": "Pago nuevo",
    "LINK_PAYMENT": "Pago existente",
    "LINK_SETTLEMENT": "Pago al comercio",
    "IGNORE": "Ignorar"
  }
}
</i18n>
